import fetchClient, { ApiResponse } from '../api-client'
import { ParcelStatusResponse } from './types/ParcelStatus'

/**
 * Get parcel delivery status by tracking number
 */
export const getParcelStatus = async (trackingNumber: string) => {
  try {
    const res = await fetchClient.get<ApiResponse<ParcelStatusResponse>>(`/shipping/parcel-status/${trackingNumber}`)
    return res.data.data || null
  } catch (error) {
    throw error
  }
}
